/* Crafteaze product page sections (ce-pdp-*) */
(function () {
  'use strict';

  // Before / after slider
  function initBA(root) {
    (root || document).querySelectorAll('[data-ce-ba]').forEach(function (box) {
      if (box.dataset.ceBound) return;
      box.dataset.ceBound = '1';
      var drag = false;
      function setPct(p) {
        p = Math.max(0, Math.min(100, p));
        box.style.setProperty('--pos', p + '%');
        box.setAttribute('aria-valuenow', Math.round(p));
      }
      function setX(x) { var r = box.getBoundingClientRect(); setPct((x - r.left) / r.width * 100); }
      box.addEventListener('pointerdown', function (e) { drag = true; setX(e.clientX); try { box.setPointerCapture(e.pointerId); } catch (_) {} });
      box.addEventListener('pointermove', function (e) { if (drag) setX(e.clientX); });
      box.addEventListener('pointerup', function () { drag = false; });
      box.addEventListener('pointercancel', function () { drag = false; });
      box.addEventListener('keydown', function (e) {
        var now = parseFloat(box.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') { e.preventDefault(); setPct(now - 5); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setPct(now + 5); }
      });
    });
  }

  // Sticky add to cart: shows once the main Add to cart button has scrolled above the screen
  function initSticky() {
    var bar = document.querySelector('[data-ce-psticky]');
    if (!bar || bar.dataset.ceBound) return;
    var atc = document.querySelector('.product__submit__add, form[action*="/cart/add"] [type="submit"]');
    if (!atc || !('IntersectionObserver' in window)) return;
    bar.dataset.ceBound = '1';
    document.body.classList.add('ce-has-psticky');
    new IntersectionObserver(function (e) {
      var show = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(atc);
    bar.querySelector('[data-ce-psticky-btn]').addEventListener('click', function () {
      if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      atc.click();
    });
  }

  function init(root) { initBA(root); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
